import styled from 'styled-components';

export const Page = styled.div`
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
`;

export const Page2 = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Content = styled.div`
  display: flex;
  height: calc(100% - 53px);
  flex-flow: row nowrap;
  background: #e8e8e8;
`;

export const SubscopeContextWrapper = styled.div`
  background: white;
  flex: 1 1 100%;
  border-right: 1px solid #e1e1e1;
`;

export const ContextHeader = styled.div`
  display: flex;
  flex-flow: row nowrap;
  flex: 0 0 63px;
  color: rgba(0, 0, 0, .9);
  text-align: center;
  background: #fff;
  min-height: 60px;
  border-bottom: 1px solid #f0f1f2;
  padding: 0px 11px;
  position: relative;
  transition: all .2s;
  align-items: center;

  & > div:not(:last-child) {
    margin-right: 10px;
  }
`;

export const ContextWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
`;

export const TimelineWrapper = styled.div`
  height: calc(100% - 60px);
`;

export const RefreshIcon = styled.img`
  width: 36px;
  height: 36px;
  cursor: pointer;
  transition: transform .2s ease-in;
  -webkit-transform-origin: 50%  51%;
  perspective: 1;

  &:hover {
    transform: rotate(370deg);
  }
`;
